import React from 'react'

export default function Privacy() {
  return (
    <div className="bg-black text-white min-h-screen py-12 px-4">
      <div className="max-w-7xl mx-auto space-y-12">
        <header className="space-y-4">
          <h1 className="text-4xl font-extrabold">Privacy Policy</h1>
          <p className="text-lg text-gray-300">
            Bristu Learning App is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and disclose your personal information when you use our services.
          </p>
        </header>

        <section className="space-y-10">
          {[
            {
              title: 'Information We Collect',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">User-Provided Information:</span> Includes name, email, and payment information.</li>
                  <li><span className="font-semibold text-white">Automatically Collected Data:</span> Such as IP address, device type, and usage patterns.</li>
                  <li><span className="font-semibold text-white">Cookies & Tracking:</span> Used to personalize content and improve user experience.</li>
                </ul>
              )
            },
            {
              title: 'How We Use Your Information',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">Service Delivery:</span> To operate and improve the platform.</li>
                  <li><span className="font-semibold text-white">Payment Processing:</span> To complete transactions securely.</li>
                  <li><span className="font-semibold text-white">Communication:</span> To send updates and respond to inquiries.</li>
                </ul>
              )
            },
            {
              title: 'Information Sharing & Disclosure',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">Service Providers:</span> Such as payment processors or email services.</li>
                  <li><span className="font-semibold text-white">Legal Requirements:</span> When required by law or legal process.</li>
                  <li><span className="font-semibold text-white">Business Transfers:</span> In the event of a merger or acquisition.</li>
                </ul>
              )
            },
            {
              title: 'Data Security',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">Security Practices:</span> We implement industry-standard safeguards.</li>
                  <li><span className="font-semibold text-white">No Absolute Guarantee:</span> No method is 100% secure.</li>
                  <li><span className="font-semibold text-white">Data Retention:</span> We retain information only as long as needed.</li>
                </ul>
              )
            },
            {
              title: 'Your Rights',
              content: (
                <ul className="list-disc list-inside space-y-2 text-gray-300">
                  <li><span className="font-semibold text-white">Access & Correction:</span> Request to view or edit your personal data.</li>
                  <li><span className="font-semibold text-white">Opt-Out:</span> Unsubscribe from promotional communications at any time.</li>
                </ul>
              )
            },
            {
              title: "Children's Privacy",
              content: (
                <p className="text-gray-300">
                  Bristu Learning App is not intended for users under the applicable age limit. We take compliance with COPPA and similar laws seriously.
                </p>
              )
            },
            {
              title: 'Changes to This Policy',
              content: (
                <p className="text-gray-300">
                  We may update this Privacy Policy from time to time. All changes will be posted on this page with a revised effective date.
                </p>
              )
            },
            {
              title: 'Contact Us',
              content: (
                <p className="text-gray-300">
                  If you have any questions about this Privacy Policy, feel free to reach out at{' '}
                  <a href="mailto:bristuappofficial@gmail.com" className="text-blue-400 underline">bristuappofficial@gmail.com</a>.
                </p>
              )
            }
          ].map((section, index) => (
            <div key={index} className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-3">
              <h2 className="text-2xl font-bold text-white">{section.title}</h2>
              <div>{section.content}</div>
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}
